import React, { useState, useEffect } from 'react';
import { Popover } from 'adp-react-components';

export default function RolesDescriptions({ userRoles, partnerType = ''  }) {
	const [ userRole, setUserRole ]= useState('');

	const roleDescriptions = [
		{
			title: 'Project user',
			description: 'Able to access project, members, and certificate tabs.',
			type: 'marketplace'
		},
		{
			title: 'Certificate user',
			description: 'Able to access the certificate tab.',
			type: 'marketplace'
		},
		{
			title: 'Revshare user',
			description: 'Able access the rev share tab.',
			type: 'marketplace'
		},
		{
			title: 'Financial user',
			description: 'This role has access to view and modify Billing and Invoice Management app.',
			type: 'marketplace'
		},
		{
			title: 'DataCloud user',
			description: 'Able to access project, members, usage, and certificate tabs.',
			type: 'datacloud'
		},
		{
			title: 'Certificate user',
			description: 'Able to access the certificate tab.',
			type: 'datacloud'
		}
	];

	useEffect(() => {
		if (userRoles.length > 0 ) {
			const isMarketPlaceUser = userRoles.includes('selfservicepartneruser');
			const isDataCloudUser = userRoles.includes('selfservicedataclouduser');
			if (isMarketPlaceUser || partnerType === 'marketplace') {
				setUserRole('marketplace');
			}
			else if (isDataCloudUser || partnerType === 'datacloud') {
				setUserRole('datacloud');
			}
		}
		else if (userRoles.length === 0 && partnerType !== '' && partnerType !== null) {
			setUserRole(partnerType);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[userRoles]);

	const createRolesDescriptionsDisplay = () => {
		return roleDescriptions.filter(role => role.type === userRole).map((role, i) => (
			<div key={'role' + i} className="role">
			<span key={'role-title' + i} className="role-title">{role.title}</span>
			<div key={'role-description' + i}>{role.description}</div>
			</div>
		));
	};
	
	const tooltip = (<Popover placement="right" style={{marginLeft: '73px'}} className="roles-descriptions" id="roles-descriptions-tooltip">
		<div className="roles-header">Role descriptions</div>
		{createRolesDescriptionsDisplay()}
	</Popover>);

	return tooltip;
}
